import React from 'react';

import WsIconProps from './IconProps';

const WsIconCopy: React.FC<WsIconProps> = ({ color = '#616893', width = 18, height = 18 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0H8C5.8 0 4 1.8 4 4C1.8 4 0 5.8 0 8V14C0 16.2 1.8 18 4 18H10C12.2 18 14 16.2 14 14C16.2 14 18 12.2 18 10V4C18 1.8 16.2 0 14 0ZM12 14C12 15.1 11.1 16 10 16H4C2.9 16 2 15.1 2 14V8C2 6.9 2.9 6 4 6H5H10C11.1 6 12 6.9 12 8V13V14ZM16 10C16 11.1 15.1 12 14 12V8C14 5.8 12.2 4 10 4H6C6 2.9 6.9 2 8 2H14C15.1 2 16 2.9 16 4V10Z"
      fill={color}
    />
  </svg>
);

export default WsIconCopy;
